export default "__VITE_ASSET__C1t9VaSD__"